import { render, staticRenderFns } from "./BaseBtnPreStep.vue?vue&type=template&id=611aa3df&scoped=true&lang=pug"
import script from "./BaseBtnPreStep.vue?vue&type=script&lang=js"
export * from "./BaseBtnPreStep.vue?vue&type=script&lang=js"
import style0 from "./BaseBtnPreStep.vue?vue&type=style&index=0&id=611aa3df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611aa3df",
  null
  
)

export default component.exports